<div class="switch" *ngIf="activity.showHideExpirationDateOption">
  <label>
    <input type="checkbox" [(ngModel)]="activity.hideExpirationDate" />
    Hide Expiration Date
  </label>
</div>
